module.exports = function() {
  return new Worker(__webpack_public_path__ + "e21f147be2451f2b9635.worker.js");
};